import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {BudgetThresholdBannerAnalytics, BudgetThresholdBannerPayload} from '@github-ui/in-product-targeting'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import {isUIService} from '@github-ui/runtime-environment'

import type {CodeViewPathParams} from './types/shared-query-types'

/**
 * JSON response from the monolith `/in-product-messaging/budget-threshold-banner`
 * endpoint. Reuses the billing team's existing banner payload contract. An empty
 * object is returned when the banner should not render (non-org owner, ineligible
 * actor, feature flag off, or no alertable budget).
 */
export interface BudgetThresholdBannerResponse {
  banner?: BudgetThresholdBannerPayload
  ctaHref?: string
  analytics?: BudgetThresholdBannerAnalytics
}

export const budgetThresholdBannerQuery = {
  queryName: 'budgetThresholdBanner' as const,
  queryDeps: ({params: routeParams}: {params: Record<string, string | undefined>}) => {
    const params = routeParams as CodeViewPathParams

    return {
      pathname: `/in-product-messaging/budget-threshold-banner?organization=${encodeURIComponent(params.owner)}`,
    }
  },
  queryFn: async (queryKey: {queryDeps: {pathname: string}}) => queryFnFetch<BudgetThresholdBannerResponse>(queryKey),
  type: QueryRouteQueryType.Deferred,
  // Only fetched in the UI service build. On dotcom, the Rails
  // `_default_container` IncludeFragment still renders this banner, so fetching
  // (and rendering) here would be wasteful and would double-render the banner.
  enabled: () => isUIService && !isFeatureEnabled('ui_service_code_view_budget_banner_eligibility'),
}
